import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useSubscription } from 'urql';
import useSubscriptionStreamStore, {
  setNextCursor,
} from '@/stores/useSubscriptionStreamStore';
import useActiveTimestamp from './useActiveTimestamp';

export default function useSubscriptionStream<T>(
  name: string,
  ...args: Parameters<typeof useSubscription<T>>
) {
  const { query } = args[0];
  const [cursor, setCursor] = useState<string | null>(() =>
    DateTime.local().toISO(),
  );
  const activeTimestamp = useActiveTimestamp();

  useEffect(() => {
    if (activeTimestamp) {
      const nextCursor = useSubscriptionStreamStore
        .getState()
        .nextCursor.get(name);

      if (nextCursor) {
        setCursor(nextCursor);
      } else {
        const now = DateTime.local().toISO();
        setCursor(now);
        setNextCursor(name, now);
      }
    } else {
      setCursor(null);
    }
  }, [activeTimestamp, name]);

  return useSubscription({
    query,
    variables: { cursor: cursor! },
    pause: !cursor,
  });
}
